import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { get, isEqual } from "lodash";
import queryString from "query-string";
import { taskIdSelector } from "views/JobDetailPage/selectors";

const useCacheDataMainTask = (statePath, initData) => {
  const location = useLocation();
  const taskId = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails.id
  );
  const activeTaskId = useSelector(taskIdSelector);
  const dataOrigin = useSelector((state) => get(state, statePath, initData));
  const [data, setData] = useState(initData);

  useEffect(() => {
    const query = queryString.parse(location.search);
    if (
      taskId === query?.task_id &&
      activeTaskId === query?.task_id &&
      !isEqual(data, dataOrigin)
    ) {
      setData(dataOrigin);
    }
  }, [activeTaskId, taskId, dataOrigin, location]);

  return data;
};

export default useCacheDataMainTask;
